const NON_BLOCKING_COPY =
  "This warning does not block the sale and does not block completing checkout. This same warning will be flagged in the review process. Please correct the issue now to avoid a pending task, or use upload docs to upload proof that the warning can be ignored.";

const OFFER_REVIEW_CONTRACT_REVIEW_INTRO_COPY =
  "The information below could cause delays after Checkout when submitting for Sunrun Approval. It is best to review and resolve these items now.";

export { NON_BLOCKING_COPY, OFFER_REVIEW_CONTRACT_REVIEW_INTRO_COPY };
